module.exports = __webpack_public_path__ + "14e5001e6217db8e16461d21c18c9236.svg";